import { Loader } from '@googlemaps/js-api-loader';

common.View.create('crud::form.inputs.Maps', {

    onDOMLoad()
    {
        const provider = this.element.find('[data-provider]').data('provider') || 'google_maps';

        if (provider === 'openstreetmap') {
            this.initOpenStreetMap();
        } else {
            this.initGoogleMap();
        }
    },

    // =========================================================================
    // Google Maps
    // =========================================================================

    initGoogleMap()
    {
        const apiKey = this.element.find('.apiKey').text();

        if (!apiKey) {
            return;
        }

        const loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
        });

        Promise.all([
            loader.importLibrary('maps'),
            loader.importLibrary('places'),
            loader.importLibrary('geocoding'),
            loader.importLibrary('marker'),
        ]).then(([mapsLib, placesLib, geocodingLib, markerLib]) => {
            this.mapsLib = mapsLib;
            this.placesLib = placesLib;
            this.geocodingLib = geocodingLib;
            this.markerLib = markerLib;
            this.setupGoogleMap();
        });

        this.updateMapLink();
    },

    setupGoogleMap()
    {
        let $lat = this.element.find('.lat').get(0),
            $lng = this.element.find('.lng').get(0),
            $zoom = this.element.find('.zoom').get(0);

        if (this.element.find('.map').length) {
            let myLatLng = { lat: parseFloat($lat.value), lng: parseFloat($lng.value) };

            this.map = new this.mapsLib.Map(this.element.find('.map').get(0), {
                zoom: parseInt($zoom.value),
                center: myLatLng,
            });

            this.marker = new this.markerLib.Marker({
                position: myLatLng,
                map: this.map,
                draggable: true,
                title: 'Versleep me!',
            });

            this.marker.addListener('dragend', (event) => {
                $lat.value = event.latLng.lat();
                $lng.value = event.latLng.lng();
                this.googleReverseGeocode(event.latLng);
            });

            this.map.addListener('dblclick', (event) => {
                this.marker.setPosition(event.latLng);
                $lat.value = event.latLng.lat();
                $lng.value = event.latLng.lng();
                this.googleReverseGeocode(event.latLng);
            });

            this.map.addListener('zoom_changed', () => {
                $zoom.value = this.map.getZoom();
            });
        }

        if (this.element.find('.address').length) {
            let autocomplete = new this.placesLib.Autocomplete(this.element.find('.address').get(0));

            autocomplete.addListener('place_changed', () => {
                let place = autocomplete.getPlace();

                if (!place.geometry) {
                    return;
                }

                $lat.value = place.geometry.location.lat();
                $lng.value = place.geometry.location.lng();

                if (this.element.find('.mapLink').length) {
                    this.element.find('.mapLink').attr('href', place.url)
                        .removeClass('pointer-events-none');
                }

                if (this.map && this.marker) {
                    if (place.geometry.viewport) {
                        this.map.fitBounds(place.geometry.viewport);
                    } else {
                        this.map.setCenter(place.geometry.location);
                        this.map.setZoom(17);
                    }
                    this.marker.setPosition(place.geometry.location);
                }
            });
        }
    },

    googleReverseGeocode(position)
    {
        let addressInput = this.element.find('.address');

        if (!addressInput.length) return;

        let geocoder = new this.geocodingLib.Geocoder();
        geocoder.geocode({ location: position }, (results, status) => {
            if (status === 'OK' && results[0]) {
                addressInput.val(results[0].formatted_address);
            }
        });
    },

    updateMapLink()
    {
        if (!this.element.find('.mapLink').length) {
            return;
        }

        this.element.find('.address').on('keyup change', (event) => {
            if (event.target.value === '') {
                this.element.find('.mapLink').attr('href', '')
                    .addClass('pointer-events-none');
            } else {
                this.element.find('.mapLink').attr('href', 'https://www.google.nl/maps/?q=' + event.target.value)
                    .removeClass('pointer-events-none');
            }
        });
    },

    // =========================================================================
    // OpenStreetMap (Leaflet)
    // =========================================================================

    initOpenStreetMap()
    {
        if (typeof L === 'undefined') {
            let check = setInterval(() => {
                if (typeof L !== 'undefined') {
                    clearInterval(check);
                    this.initOpenStreetMap();
                }
            }, 100);
            return;
        }

        this.skipNextSearch = false;

        if (this.element.find('.map').length) {
            this.setupLeafletMap();
        }

        if (this.element.find('.address').length && this.element.find('.search-results').length) {
            this.setupOsmAddressSearch();
        }
    },

    setupLeafletMap()
    {
        let $lat = this.element.find('.lat').get(0),
            $lng = this.element.find('.lng').get(0),
            $zoom = this.element.find('.zoom').get(0);

        let lat = parseFloat($lat.value),
            lng = parseFloat($lng.value),
            zoom = parseInt($zoom ? $zoom.value : 12);

        this.map = L.map(this.element.find('.map').get(0), { zoomControl: true }).setView([lat, lng], zoom);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this.map);

        let markerIcon = L.divIcon({
            html: '<i class="fa-solid fa-location-dot text-primary text-3xl" style="filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));"></i>',
            className: 'fa-marker',
            iconSize: [30, 36],
            iconAnchor: [15, 36],
        });

        this.marker = L.marker([lat, lng], {
            icon: markerIcon,
            draggable: true,
            title: 'Versleep me!',
        }).addTo(this.map);

        this.marker.on('dragend', (e) => {
            let pos = e.target.getLatLng();
            $lat.value = pos.lat;
            $lng.value = pos.lng;
            this.osmReverseGeocode(pos.lat, pos.lng);
        });

        this.map.on('dblclick', (e) => {
            this.marker.setLatLng(e.latlng);
            $lat.value = e.latlng.lat;
            $lng.value = e.latlng.lng;
            this.osmReverseGeocode(e.latlng.lat, e.latlng.lng);
        });

        this.map.on('zoomend', () => {
            if ($zoom) {
                $zoom.value = this.map.getZoom();
            }
        });

        let addressInput = this.element.find('.address');
        if (addressInput.length && !addressInput.val().trim() && lat && lng) {
            this.osmReverseGeocode(lat, lng);
        }
    },

    // -------------------------------------------------------------------------
    // OpenStreetMap: Reverse Geocoding (Nominatim)
    // -------------------------------------------------------------------------

    osmReverseGeocode(lat, lng)
    {
        let addressInput = this.element.find('.address');
        if (!addressInput.length) return;

        fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1`)
            .then(r => r.json())
            .then(data => {
                if (data) {
                    this.skipNextSearch = true;
                    addressInput.val(this.osmFormatAddress(data));
                    addressInput.get(0).dispatchEvent(new Event('input', { bubbles: true }));
                    addressInput.get(0).dispatchEvent(new Event('change', { bubbles: true }));
                }
            })
            .catch(err => console.error('Reverse geocode error:', err));
    },

    osmFormatAddress(result)
    {
        let addr = result.address || {};
        let parts = [];

        let street = addr.road || addr.street || addr.pedestrian || '';
        let houseNumber = addr.house_number || '';
        if (street) {
            parts.push(houseNumber ? `${street} ${houseNumber}` : street);
        }

        let postcode = addr.postcode || '';
        let city = addr.city || addr.town || addr.village || addr.municipality || '';
        if (postcode || city) {
            parts.push([postcode, city].filter(Boolean).join(' '));
        }

        if (parts.length === 0 && (addr.country || '')) {
            parts.push(addr.country);
        }

        return parts.length > 0 ? parts.join(', ') : result.display_name;
    },

    // -------------------------------------------------------------------------
    // OpenStreetMap: Address Search (Photon + Nominatim fallback)
    // -------------------------------------------------------------------------

    setupOsmAddressSearch()
    {
        let addressInput = this.element.find('.address');
        let searchResults = this.element.find('.search-results');
        let searchTimeout;

        addressInput.on('input', (e) => {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                this.osmSearchAddress(e.target.value);
            }, 300);
        });

        addressInput.on('focus', () => {
            if (addressInput.val().length >= 3) {
                this.osmSearchAddress(addressInput.val());
            }
        });

        $(document).on('click', (e) => {
            if (!$(e.target).closest(this.element).length) {
                searchResults.addClass('hidden');
            }
        });

        addressInput.on('keydown', (e) => {
            if (e.key === 'Escape') {
                searchResults.addClass('hidden');
            }
        });
    },

    osmSearchAddress(query)
    {
        if (this.skipNextSearch) {
            this.skipNextSearch = false;
            return;
        }

        let searchResults = this.element.find('.search-results');
        if (!query || query.length < 3) {
            searchResults.addClass('hidden');
            return;
        }

        fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&limit=10`)
            .then(response => {
                if (!response.ok) {
                    return fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5&addressdetails=1`)
                        .then(r => r.json())
                        .then(data => ({ nominatim: true, data }));
                }
                return response.json().then(data => ({ nominatim: false, data }));
            })
            .then(result => {
                searchResults.empty();

                let items = result.nominatim
                    ? this.osmParseNominatimResults(result.data, query)
                    : this.osmParsePhotonResults(result.data, query);

                if (items.length === 0) {
                    searchResults.addClass('hidden');
                    return;
                }

                items.forEach((item, index) => {
                    let el = this.osmCreateResultElement(item, index, items.length);
                    el.on('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.osmSelectResult(item.lat, item.lng, item.formatted);
                    });
                    searchResults.append(el);
                });

                searchResults.removeClass('hidden');
            })
            .catch(err => console.error('Search error:', err));
    },

    osmParseNominatimResults(data, query)
    {
        if (!data || data.length === 0) return [];

        return data
            .map(item => {
                let addr = item.address || {};
                let street = addr.road || addr.street || addr.pedestrian || '';
                let houseNumber = addr.house_number || '';
                let postcode = addr.postcode || '';
                let city = addr.city || addr.town || addr.village || addr.municipality || '';

                return {
                    mainLine: street ? (houseNumber ? `${street} ${houseNumber}` : street) : (item.name || (item.display_name || '').split(',')[0] || 'Onbekende locatie'),
                    subLine: [postcode, city].filter(Boolean).join(' '),
                    formatted: this.osmFormatAddress(item),
                    lat: parseFloat(item.lat),
                    lng: parseFloat(item.lon),
                    score: this.osmScoreResult(item, query, false),
                };
            })
            .filter(r => r.score > 0)
            .sort((a, b) => b.score - a.score)
            .slice(0, 5);
    },

    osmParsePhotonResults(data, query)
    {
        if (!data || !data.features || data.features.length === 0) return [];

        return data.features
            .map(feature => {
                let props = feature.properties || {};
                let coords = feature.geometry ? feature.geometry.coordinates : [];
                let street = props.street || props.name || '';
                let houseNumber = props.housenumber || '';
                let postcode = props.postcode || '';
                let city = props.city || props.town || props.village || props.locality || '';

                let parts = [];
                if (street) parts.push(houseNumber ? `${street} ${houseNumber}` : street);
                if (postcode || city) parts.push([postcode, city].filter(Boolean).join(' '));

                return {
                    mainLine: street ? (houseNumber ? `${street} ${houseNumber}` : street) : (props.name || 'Onbekende locatie'),
                    subLine: [postcode, city].filter(Boolean).join(' '),
                    formatted: parts.join(', ') || props.name || '',
                    lat: coords[1],
                    lng: coords[0],
                    score: this.osmScoreResult(feature, query, true),
                };
            })
            .filter(r => r.score > 0)
            .sort((a, b) => b.score - a.score)
            .slice(0, 5);
    },

    osmScoreResult(result, query, isPhoton)
    {
        let q = query.toLowerCase().trim();
        let parts = q.split(',').map(p => p.trim());
        let streetPart = parts[0] || '';
        let locationPart = parts[1] || '';

        let houseNumberMatch = streetPart.match(/^(.+?)\s+(\d+\s*\w*)$/);
        let streetQuery = houseNumberMatch ? houseNumberMatch[1] : streetPart;
        let houseNumberQuery = houseNumberMatch ? houseNumberMatch[2] : null;

        let postcodeMatch = locationPart.match(/^(\d{4}\s*[A-Za-z]{2})\s*(.*)$/);
        let postcodeQuery = postcodeMatch ? postcodeMatch[1].replace(/\s/g, '').toLowerCase() : null;
        let cityQuery = postcodeMatch ? postcodeMatch[2].toLowerCase() : locationPart.toLowerCase();

        let streetName, houseNumber, cityName, postcode;

        if (isPhoton) {
            let props = result.properties || {};
            streetName = (props.street || props.name || '').toLowerCase();
            houseNumber = (props.housenumber || '').toLowerCase();
            cityName = (props.city || props.town || props.village || '').toLowerCase();
            postcode = (props.postcode || '').replace(/\s/g, '').toLowerCase();
        } else {
            let addr = result.address || {};
            streetName = (addr.road || addr.street || addr.pedestrian || result.name || '').toLowerCase();
            houseNumber = (addr.house_number || '').toLowerCase();
            cityName = (addr.city || addr.town || addr.village || '').toLowerCase();
            postcode = (addr.postcode || '').replace(/\s/g, '').toLowerCase();
        }

        let score = 0;

        if (streetName.includes(streetQuery) || streetQuery.includes(streetName)) {
            score += 2;
            if (streetName.startsWith(streetQuery)) score += 1;
        }

        if (houseNumberQuery && houseNumber) {
            if (houseNumber.startsWith(houseNumberQuery.trim())) score += 2;
            else score += 1;
        }

        if (postcodeQuery && postcode) {
            if (postcode.startsWith(postcodeQuery)) score += 2;
        }

        if (cityQuery && cityName) {
            if (cityName.includes(cityQuery) || cityQuery.includes(cityName)) score += 1;
        }

        if (score === 0) {
            let fullText = [streetName, houseNumber, postcode, cityName].filter(Boolean).join(' ');
            if (fullText.includes(q.replace(/,/g, ' ').replace(/\s+/g, ' '))) score = 1;
        }

        return score;
    },

    osmCreateResultElement(item, index, total)
    {
        return $('<div/>')
            .addClass('px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors' + (index < total - 1 ? ' border-b border-gray-100' : ''))
            .html(
                '<div class="flex items-start gap-3">' +
                '<i class="fa-solid fa-location-dot text-primary mt-0.5"></i>' +
                '<div class="flex-1 min-w-0">' +
                '<div class="font-medium text-gray-900 truncate">' + item.mainLine + '</div>' +
                (item.subLine ? '<div class="text-sm text-gray-500 truncate">' + item.subLine + '</div>' : '') +
                '</div></div>'
            );
    },

    osmSelectResult(lat, lng, formattedAddress)
    {
        this.element.find('.lat').val(lat);
        this.element.find('.lng').val(lng);

        let addressInput = this.element.find('.address');
        if (addressInput.length) {
            this.skipNextSearch = true;
            addressInput.val(formattedAddress);
            addressInput.get(0).dispatchEvent(new Event('input', { bubbles: true }));
            addressInput.get(0).dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (this.map && this.marker) {
            this.map.setView([lat, lng], 15);
            this.marker.setLatLng([lat, lng]);
        }

        this.element.find('.search-results').addClass('hidden').empty();
    },

});
